export default __webpack_public_path__ + "static/media/iconTeam.77611366.svg";